'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgCallCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M2 8c0 1.177.338 2.311.98 3.287-.21.238-.391.403-.54.498a.732.732 0 00.11 1.292c.248.105.562.167.94.167.391 0 .814-.068 1.26-.2C5.718 13.67 6.841 14 8 14c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6zm4.714-2.571h-1a.287.287 0 00-.285.285 4.857 4.857 0 004.857 4.857.287.287 0 00.285-.285v-.997a.287.287 0 00-.285-.286c-.355 0-.7-.057-1.02-.163a.293.293 0 00-.291.069l-.63.628a4.328 4.328 0 01-1.882-1.883l.628-.628a.287.287 0 00.072-.292A3.246 3.246 0 017 5.714a.287.287 0 00-.286-.285z", fill: "currentColor" }))));
}

module.exports = SvgCallCircle;
//# sourceMappingURL=CallCircle.js.map
